"use client";

import { LoginBridge } from "@/components/portal/login-bridge";

// Não há tela de login própria: o login é o do portal. Esta página é a ponte (ver
// LoginBridge) e o redirectUri do MSAL.
export default function LoginPage() {
  return <LoginBridge />;
}
